"use client";

import type { AssistantStaticBubbleVariantProps, UserStaticBubbleVariantProps } from "@ui/components/core/BaseChat";
import {
  assistantBubbleBackgroundVariants,
  assistantBubbleRootVariants,
  userBubbleBackgroundVariants,
  userBubbleRootVariants,
} from "@ui/components/core/BaseChat";

import "./ChatScenarioTypingIndicator.css";

// Using a CSS @keyframes (defined in the sibling stylesheet) instead of motion's keyframe animation.
// The repo's LazyMotion `strict` + `domMax` setup reliably animates `opacity` keyframes but never produced
// visible `y` / transform keyframes in same-bubble dots — CSS animation is feature-flag-free and guaranteed.
const TYPING_DOT_STAGGER_SECONDS = 0.13;

export function TypingDots() {
  return (
    <span className='tw-flex tw-items-center tw-gap-[3px] tw-py-1' aria-hidden>
      {[0, 1, 2].map(dotIndex => (
        <span
          key={dotIndex}
          className='tw-inline-block tw-size-[5px] tw-rounded-full tw-bg-current'
          style={{
            animation: "mw-typing-dot-bounce 1.3s infinite",
            animationDelay: `${dotIndex * TYPING_DOT_STAGGER_SECONDS}s`,
          }}
        />
      ))}
    </span>
  );
}

export function ChatScenarioAssistantTypingIndicator({
  assistantMessageVariants,
}: {
  assistantMessageVariants: AssistantStaticBubbleVariantProps;
}) {
  return (
    <div role='presentation' aria-hidden className={assistantBubbleRootVariants(assistantMessageVariants)}>
      <div aria-hidden className={assistantBubbleBackgroundVariants(assistantMessageVariants)} />
      <TypingDots />
    </div>
  );
}

export function ChatScenarioUserTypingIndicator({
  userMessageVariants,
}: {
  userMessageVariants: UserStaticBubbleVariantProps;
}) {
  return (
    <div role='presentation' aria-hidden className={userBubbleRootVariants(userMessageVariants)}>
      <div aria-hidden className={userBubbleBackgroundVariants(userMessageVariants)} />
      <TypingDots />
    </div>
  );
}
